(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-contact-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-contact-panel')) {
    customElements.define('bc-contact-panel', class extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onReset = this.onReset.bind(this);
      }

      connectedCallback() {
        this.inquiry = this.querySelector('[data-bc-inquiry]');
        if (!this.inquiry) return;
        this.addEventListener('change', this.onChange);
        this.addEventListener('reset', this.onReset);
        this.updateFields();

        const result = this.querySelector('[data-bc-result]');
        const form = this.querySelector('form');
        if (result && form && window.location.hash === '#' + form.id) result.focus();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('reset', this.onReset);
        window.clearTimeout(this.resetTimer);
      }

      onChange(event) {
        if (event.target === this.inquiry) this.updateFields();
      }

      onReset() {
        window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(() => this.updateFields(), 0);
      }

      updateFields() {
        const type = this.inquiry.value;
        const visibility = {
          order: ['Order Support', 'Shipping & After-Sales'].includes(type),
          business: ['Wholesale Inquiry', 'Private Label / Customization', 'Business Cooperation'].includes(type)
        };
        this.querySelectorAll('[data-bc-show-for]').forEach((group) => {
          const visible = Boolean(visibility[group.dataset.bcShowFor]);
          group.hidden = !visible;
          group.querySelectorAll('input, select, textarea').forEach((field) => {
            field.disabled = !visible;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

if (!customElements.get('bc-footer-four')) {
  customElements.define('bc-footer-four', class extends HTMLElement {
    constructor() {
      super();
      this.updateLayout = this.updateLayout.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', this.updateLayout);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.updateLayout();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.updateLayout, { once: true });
      }
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.updateLayout);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('DOMContentLoaded', this.updateLayout);
    }

    updateLayout() {
      const mobile = this.mobileQuery.matches;
      this.querySelectorAll('.bc-footer-menu').forEach((menu) => {
        menu.open = !mobile;
        const summary = menu.querySelector('summary');
        if (summary) summary.tabIndex = mobile ? 0 : -1;
      });
    }

    onClick(event) {
      const summary = event.target.closest('.bc-footer-menu__summary');
      if (summary && this.contains(summary) && !this.mobileQuery.matches) {
        event.preventDefault();
      }
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const menu = event.target.closest('.bc-footer-menu') || event.target.querySelector('.bc-footer-menu');
      if (menu) menu.open = true;
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
